import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { formatRangeValue } from '@features/filter/static/filterUtil';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

const Weight = () => {
	const [weightValue, setWeightValue] = useState({ min: '', max: '' });
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);
	const dispatch = useDispatch();
	const weightRef = useRef(null);

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'WEIGHT') dispatch(clearSelectedFilterName());
	};

	useClickOutside(weightRef, onOutSideClick);

	const onApplyChange = () => {
		let data = {
			name: 'WEIGHT',
			key: weightValue,
			minGsm: parseFloat(weightValue.min),
			maxGsm: parseFloat(weightValue.max),
			value: `Weight: ${formatRangeValue(weightValue)}`,
			identifier: `weightIds`,
			type: 'INPUT_VALUE'
		};
		dispatch(storeItemInGlobalFilter(data));
		onClearInputFields();
	};

	const onClearInputFields = () => {
		setWeightValue({ min: '', max: '' });
	};

	const onChangeWeight = (e) => {
		const { name, value } = e.target;
		setWeightValue((prev) => ({
			...prev,
			[name]: value
		}));
	};

	return (
		<div>
			<FilterName type="WEIGHT" />
			<div ref={weightRef}>
				<FilterInput
					type="WEIGHT"
					onApplyHandler={onApplyChange}
					onChangeHandler={onChangeWeight}
					inputValue={weightValue}
					onClearInputFields={onClearInputFields}
				/>
			</div>
		</div>
	);
};

export default Weight;
